const { NODE_ENV: env = 'local', PORT: port = 8080 } = process.env;

module.exports = {
  env,
  port,
  debug: true,
  mode: 'development',
  sourceMap: true,
  hot: true,
  favicon: true,
  lsOnlineUrlRoot: 'https://development.ls-www.localsearch.cloud',
  b2bRoot: 'https://business.localsearch.com.au',
  imageResizeRoot: 'https://d1zmvcyjeoeklt.cloudfront.net',
  api: 'https://development.services.lsapis.com.au',
  b2bApi: 'https://lsb2bstaging.wpengine.com/wp-json/localsearch',
  // api: 'http://localhost:3000',
  googleMapsApiKey: 'AIzaSyD1scZ4h2kbYhTIMS4zFiiKRDD4wlDPBb0',
  auth: {
    responseType: 'token id_token',
    scope: 'openid',
  },
  token: {
    tolerance: 5 * 60 * 1000, // 5 minutes
    cookie: { domain: '.localsearch.cloud' },
  },
  maxUploadSize: 10485760, // 10MB;
  contactUsMailToPath: 'mailto:productsquoting@localsearch.com.au',
};
